import styled, { css } from 'styled-components';
import { IconGlyph } from '@/app/common/icons/MaskIcon';

export const SearchListContainer = styled.div<{ isOpen: boolean; disabled?: boolean; isMobile?: boolean }>`
  width: 100%;
  position: relative;

  ${({ isOpen, isMobile }) =>
    isOpen &&
    isMobile &&
    css`
      box-shadow: ${({ theme }): string => theme.kallisto.shadow.largeDownShadow};
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      label {
        opacity: 0.5;
      }
    `}
`;

export const Overlay = styled.div<{ hasContainer: boolean; isMobile?: boolean }>`
  position: absolute;
  background-color: #fff;
  top: 61px;
  max-height: 240px;
  overflow: hidden;
  overflow-y: auto;
  box-shadow:
    0 24px 32px rgba(0, 0, 0, 0.04),
    0 16px 24px rgba(0, 0, 0, 0.04),
    0 4px 8px rgba(0, 0, 0, 0.04),
    0 0 10px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  width: 100%;
  z-index: 3;

  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar {
    width: 3px;
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  }

  &::-webkit-scrollbar-thumb {
    background-color: #080808;
  }

  ${({ hasContainer }) =>
    hasContainer &&
    css`
      top: 69px;
    `};

  ${({ isMobile }) =>
    isMobile &&
    css`
      //width: calc(100% - 32px);
      //top: 92px;
      //max-height: 100vh;
      width: 100%;
      top: 68px;
      max-height: 100vh;
    `}
`;

export const NoResults = styled.div`
  height: 36px;
  line-height: 36px;
  padding: 0 16px;
  color: ${({ theme }) => theme.kallisto.color.common.semantic.error[400]};
`;

export const MobileTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  height: 50px;
  z-index: 1;
  padding: 0 !important;

  ${IconGlyph} {
    margin: 18px;
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  }
  span {
    width: calc(100% - 76px);
    text-align: center;
    font-size: ${({ theme }) => theme.kallisto.font.size['200']};
    font-weight: 700;
  }
`;
